import { Box, BoxProps } from '@hopin-team/ui-box';
import { Butticon as UIButticon, ButticonProps } from '@hopin-team/ui-butticon';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { SpaceProps } from '@hopin-team/ui-helper-with-space';
import { MenuContent as PlanetaryMenuContent } from '@hopin-team/ui-menu';
import { Tabs } from '@hopin-team/ui-tabs';
import { rem } from 'polished';
import React from 'react';
import styled, { StyledComponent } from 'styled-components';

export const TabsWithPadding = styled(Tabs)`
  padding-top: ${rem(16)};

  [role='tablist'] > div {
    border-bottom: 0.125rem solid
      ${({ theme }) => getFromTheme('COLOR.BLUE.500', theme)};
  }
`;

export const Butticon: StyledComponent<
  React.ComponentType<ButticonProps>,
  any,
  SpaceProps
> = styled(UIButticon)`
  & > div {
    align-items: center;
    justify-content: center;
  }
  & > [role='status'] {
    right: 0;
    top: ${rem(-4)};
    width: ${rem(8)};
    height: ${rem(8)};
    & div {
      display: block;
    }
  }
  svg {
    // Temporary workaround for a mobile icon issue. See https://hopiin.slack.com/archives/C014LSCV6Q2/p1623913763076400
    height: ${rem(16)};
  }
`;

const Table = styled.table`
  width: 100%;
  text-align: left;
  font-size: ${rem(14)};
  border-spacing: 0;
`;

const Th = styled.th<{ width?: number }>`
  text-align: left;
  font-weight: 600;
  padding: ${rem(14)};

  ${({ width }) => width && `width: ${rem(width)}`};
`;

const EmptyTextWrapper = styled.div`
  width: ${rem(400)};
  text-align: center;
`;

const SearchContainer: StyledComponent<
  React.ComponentType<BoxProps>,
  any,
  SpaceProps
> = styled(Box)`
  input {
    width: 100%;
    padding-left: ${rem(16)};
  }
`;

const SearchFieldButticon = styled(Butticon)`
  background-color: ${({ theme }) => getFromTheme('COLOR.GREY.100', theme)};
  &:hover {
    background-color: ${({ theme }) => getFromTheme('COLOR.GREY.100', theme)};
  }
`;

const MenuContent = styled(PlanetaryMenuContent)`
  color: ${({ theme }) => getFromTheme('COLOR.GREY.900', theme)};
  border: 1px solid ${({ theme }) => getFromTheme('COLOR.GREY.300', theme)};
`;

export {
  Table,
  Th,
  EmptyTextWrapper,
  SearchContainer,
  SearchFieldButticon,
  MenuContent,
};
